import { Component } from '@angular/core';

@Component({
  selector: 'qw-integrations',
  template: '<router-outlet></router-outlet>'
})
export class IntegrationsComponent {}
